import { AI_ENDPOINTS } from 'features/ai-generators/constants';
import { SECONDARY_API_CLIENT } from 'services/API';

export const generateBulkEmail = async data => {
  return SECONDARY_API_CLIENT.post(AI_ENDPOINTS.bulkEmailAi, data);
};

export const rateBulkEmailAiGenerated = async ({ id, score }) => {
  return SECONDARY_API_CLIENT.post(AI_ENDPOINTS.rateBulkEmailAiGenerated, { id, score });
};
